// ----------------------------------------------------------------------
// <copyright file="Izenda.Connect.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var toClass = require('recompose').toClass;
  var withContext = require('recompose').withContext;

  var observer = require('mobx-react').observer;
  var withRouter = require('react-router').withRouter;
  var connectContextToProps = require('./Izenda.ConnectContextToProps');
  var connectActions = require('./Izenda.ConnectActions');
  var Authorization = require('share/components/hoc/Izenda.Authorization');
  var LicenseChecker = require('share/components/hoc/Izenda.LicenseChecker');

  const { forEach, isObject, isNil, pull, head, isPlainObject } = require('lodash/fp');

  /**
   * Connect the enhancers to component.
   */
  module.exports = function connect() {
    // convert arguments to real array
    var args = Array.prototype.slice.call(arguments);
    var authorizationEnhancer;
    var licenseCheckerEnhancer;
    forEach(function(arg) {
      if (isObject(arg)) {
        if (!isNil(arg.permissionKeys)) {
          authorizationEnhancer = Authorization.bind(null, arg.permissionKeys, arg.onAuth);
          args = pull(arg, args);
        }

        if (!isNil(arg.licenseKey)) {
          licenseCheckerEnhancer = LicenseChecker.bind(null, arg.licenseKey, arg.onLicense);
          args = pull(arg, args);
        }
      }
    }, args);

    // assume options will be passed at first argument if having
    var options = head(args);
    // take the rest of enhance functions
    var otherEnhancers = options && isPlainObject(options) ? args.slice(1) : args;

    var defaultEnhancers = [connectContextToProps, withRouter, connectActions];

    // determine whether needs to convert to statefull compoment using toClass
    var toClassEnhancer = options && isPlainObject(options) && options.toClass ? [toClass] : [];

    var changeContext =
      options && isPlainObject(options) && options.context
        ? [withContext(options.context.childContextTypes, options.context.getChildContext)]
        : [];

    var enhancers = toClassEnhancer
      .concat(changeContext)
      .concat(defaultEnhancers)
      .concat(otherEnhancers)
      .concat([observer]);

    if (!isNil(authorizationEnhancer)) enhancers = enhancers.concat(authorizationEnhancer);

    if (!isNil(licenseCheckerEnhancer)) enhancers = enhancers.concat(licenseCheckerEnhancer);

    return compose.apply(null, enhancers);
  };
})();



// WEBPACK FOOTER //
// ./ui/share/enhancers/Izenda.Connect.js